import { Injectable } from '@angular/core';
import { ApplicationType, BaseAppInitManagerService, IModuleModel, SharedAppActions, SharedAppState } from '@shared/core';
import { ModuleMapper } from '@shared/data';
import { Observable, catchError, map, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class AppInitManagerService extends BaseAppInitManagerService {
    public appInitError$ = this.store.select(SharedAppState.appInitError$);
    public appModules$ = this.store.select(SharedAppState.appModules$);
    public appPwaSettings$ = this.store.select(SharedAppState.appPwaSettings$);
    public appType$ = of(ApplicationType.MCL);

    public setAppInitError(): Observable<void> {
        return this.store.dispatch(new SharedAppActions.SetAppInitError());
    }

    public loadAppModules(): Observable<IModuleModel[]> {
        return this.appModulesClientService.getModules(null, ApplicationType.MCL).pipe(
            map(modules => {
                const mapper = new ModuleMapper();
                const mappedModules = mapper.mapModulesFromModulesDto(modules);
                return mappedModules;
            }),
            switchMap(mappedModules => this.store.dispatch(new SharedAppActions.SetApplicationModules(mappedModules)).pipe(map(() => mappedModules))),
            catchError(error => {
                throw error;
            }),
        );
    }
}
